// Shared blueprint type and status utilities

export const BLUEPRINT_TYPES = {
  mechanical: { label: "Mechanical", color: "#2563EB" },
  electrical: { label: "Electrical", color: "#EAB308" },
  hydraulic: { label: "Hydraulic", color: "#10B981" },
  facilities_electrical: { label: "Fac. Electrical", color: "#8B5CF6" },
  facilities_structural: { label: "Fac. Structural", color: "#F97316" },
};

export const BLUEPRINT_STATUSES = {
  pending: { label: "Pending", color: "#64748B" },
  categorized: { label: "Categorized", color: "#10B981" },
  missing: { label: "Missing", color: "#DC2626" },
};

export const MAINTENANCE_STATUSES = {
  scheduled: { label: "Scheduled", color: "#EAB308" },
  completed: { label: "Completed", color: "#10B981" },
  overdue: { label: "Overdue", color: "#DC2626" },
};

export function getTypeColor(type) {
  return BLUEPRINT_TYPES[type]?.color || "#64748B";
}

export function getTypeLabel(type) {
  return BLUEPRINT_TYPES[type]?.label || type;
}

export function getStatusColor(status) {
  return BLUEPRINT_STATUSES[status]?.color || "#64748B";
}

export function getMaintenanceStatusColor(status) {
  return MAINTENANCE_STATUSES[status]?.color || "#64748B";
}
